import { createContext } from "react";
import type { AttachmentAdapter, AttachmentRef } from "../index";
import type { AttachmentLabels } from "./attachments/labels";

/**
 * What an attachment needs of its host to draw itself. It is in a context because an attachment
 * is mounted by the editor's decorators, far from `<Editor>`'s props, and because a node is
 * handed its renderer once: what changes between renders reaches it this way instead.
 */
export interface AttachmentHost {
  /** Where the bytes are. `null` in an editor that was given none and only shows what is stored. */
  adapter: AttachmentAdapter | null;
  labels: Partial<AttachmentLabels>;
  readOnly: boolean;
  /** Somebody asked to open a file. Never implies permission. */
  onOpen: ((attachment: AttachmentRef) => void) | undefined;
}

export const AttachmentContext: React.Context<AttachmentHost> = createContext<AttachmentHost>({
  adapter: null,
  labels: {},
  readOnly: true,
  onOpen: undefined,
});
